var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "about" },
    [
      _c("Header"),
      _vm._v(" "),
      _c("Aboutus"),
      _vm._v(" "),
      _c("CategoryFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/mobile/Aboutus.vue